module.exports = __webpack_public_path__ + "img/icon-download-primary.19a1cc4c.svg";